var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3125 2.875C4.3125 2.1125 4.6154 1.38124 5.15457 0.842068C5.69373 0.302901 6.425 0 7.1875 0L15.8125 0C16.575 0 17.3063 0.302901 17.8454 0.842068C18.3846 1.38124 18.6875 2.1125 18.6875 2.875V20.125C18.6875 20.8875 18.3846 21.6188 17.8454 22.1579C17.3063 22.6971 16.575 23 15.8125 23H7.1875C6.425 23 5.69373 22.6971 5.15457 22.1579C4.6154 21.6188 4.3125 20.8875 4.3125 20.125V2.875ZM12.9375 18.6875C12.9375 18.3063 12.786 17.9406 12.5165 17.671C12.2469 17.4015 11.8812 17.25 11.5 17.25C11.1188 17.25 10.7531 17.4015 10.4835 17.671C10.214 17.9406 10.0625 18.3063 10.0625 18.6875C10.0625 19.0687 10.214 19.4344 10.4835 19.704C10.7531 19.9735 11.1188 20.125 11.5 20.125C11.8812 20.125 12.2469 19.9735 12.5165 19.704C12.786 19.4344 12.9375 19.0687 12.9375 18.6875Z",
    fill: "#0085FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.544d06b2a3b8c8af29d3f9abd30a470e.svg";
export { ForwardRef as ReactComponent };